import { defineMessages } from 'react-intl'


export default defineMessages({
  byClicking: {
    defaultMessage: "By clicking “Accept,” you agree to our website's data use on this website only as described in our “<cookiePolicyLink>Cookie Policy</cookiePolicyLink>.” You may change or withdraw your consent at any time by clicking the “<preferencesLink>Consent Preferences</preferencesLink>” link in the footer and accessing the categories, purposes, and vendors tabs.",
    id: 'tcf-consent-message.agree-to-use-paragraph',
  },
})
